import * as tslib_1 from "tslib";
function addListener(target, type, listener, capture) {
    if (target.addEventListener) {
        target.addEventListener(type, listener, capture);
        return {
            remove: function () {
                this.remove = function () { };
                target.removeEventListener(type, listener, capture);
            }
        };
    }
    throw new Error("target must be an event emitter");
}
function parse(target, type, listener, capture) {
    if (type.indexOf(",") > -1) {
        var events = type.split(/\s*,\s*/);
        var handles_1 = events.map(function (type) { return addListener(target, type, listener, capture); });
        return {
            remove: function () {
                this.remove = function () { };
                var handle;
                while ((handle = handles_1.pop())) {
                    handle.remove();
                }
            }
        };
    }
    return addListener(target, type, listener, capture);
}
var listen = function (target, type, listener, capture) {
    if (capture === void 0) { capture = false; }
    return parse(target, type, listener, capture);
};
var ɵ0 = listen;
var listenOnce = function (target, type, listener, capture) {
    if (capture === void 0) { capture = false; }
    var handle = listen(target, type, function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        handle.remove();
        listener.apply(void 0, tslib_1.__spread(args));
    }, capture);
    return handle;
};
var ɵ1 = listenOnce;
var pausable = function (target, type, listener, capture) {
    if (capture === void 0) { capture = false; }
    var paused = false;
    var handle = listen(target, type, function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!paused) {
            listener.apply(void 0, tslib_1.__spread(args));
        }
    }, capture);
    return {
        remove: function () {
            handle.remove();
        },
        pause: function () {
            paused = true;
        },
        resume: function () {
            paused = false;
        }
    };
};
var ɵ2 = pausable;
var stopEvent = function (evt) {
    if (evt.stopPropagation) {
        evt.stopPropagation();
    }
    evt.preventDefault();
};
var ɵ3 = stopEvent;
var dispatch = function (host, eventType, options) {
    if (options === void 0) { options = {}; }
    return host.dispatchEvent(new CustomEvent(eventType, Object.assign({ bubbles: false }, options)));
};
var ɵ4 = dispatch;
export { listen, dispatch, listenOnce, pausable, stopEvent };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
//# sourceMappingURL=dom-events.js.map